export default [
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Profile.vue"),
    meta: {
      layout: "Split",
      showBack: true,
      requiresAuth: true
    }
  },
  {
    path: "/profile/login",
    name: "login",
    component: () =>
    import(/* webpackChunkName: "profile" */ "@/views/account/Login.vue"),
    meta: {
      layout: "Full",
      showBack: true
    }
  },
  {
    path: "/profile/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Register.vue"),
    meta: {
      layout: "Full",
      showBack: true
    }
  },
  {
    path: "/profile/forget",
    name: "forget",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Forget.vue"),
    meta: {
      layout: "Full",
      showBack: true
    }
  },
  {
    path: "/subscribe",
    name: "subscribe",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Subscribe.vue"),
    meta: {
      layout: "Full",
      showBack: true,
      requiresAuth: true
    }
  },
  {
    path: "/features",
    name: "features",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Features.vue"),
    meta: {
      layout: "Full",
      showBack: true,
      requiresAuth: true
    }
  },
  {
    path: "/payment-done/:type",
    name: "payment-done",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/PostPayment.vue"),
    meta: {
      layout: "Full",
      requiresAuth: true
    }
  },
  {
    path: "/payment-update",
    name: "payment-update",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/UpdatePayment.vue"),
    meta: {
      layout: "Full",
      showBack: true
    }
  },
  {
    path: "/payment-done",
    name: "done-payment",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/DonePayment.vue"),
    meta: {
      layout: "Full"
    }
  },
  {
    path: "/payment/:type",
    name: "payment",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/account/Payment.vue"),
    meta: {
      layout: "Full",
      showBack: true,
      requiresAuth: true
    }
  }
];
